
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import dayjs from "dayjs";
import CouponContent from "../components/coupon-discount-content.vue";
import t from "@common/src/i18n/t";
import { InjectFunction } from "@common/src/utils/decorator";
import CouponPreview from "./components/coupon-preview.vue";
import ItemBlock from "@common/src/components/scope/item-block/index.vue";
const user = namespace("user");
const coupon = namespace("coupon");
const store = namespace("store");
@InjectFunction("dayjs", "permitApp")
@Component({
  components: {
    CouponContent,
    CouponPreview,
    ItemBlock
  }
})
export default class LookCoupon extends Vue {
  @coupon.Action getDetail;
  @user.State userData;
  @user.State selectedOrgCode;
  @store.State storeData;
  dayjs = dayjs;
  get breadData() {
    return [
      { name: t("marketing.discount-coupon"), path: "/marketing/discount-coupon" },
      { name: t("v210831.view-coupons") }
    ];
  }
  disInput = "1";
  activityStatus = null;
  couponForm = {
    activityName: "",
    time: null, //[new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)]
    number: null,
    remark: null,
    totalQuantity: "",
    activityDesc: "",
    type: "",
    radio: "1",
    radioNumber: null,
    radioNumberYuan: undefined,
    activityBegin: undefined,
    activityEnd: undefined,
    doorsill: undefined,
    multipleValue: [],
    multipleProject: [],
    couponType: undefined,
    rewardType: undefined,
    rewardValue: "",
    productDetails: [],
    limitAmount: undefined,
    storeTypesDesc: []
  };

  mounted() {
    this.init();
  }
  async init() {
    let res = await this.getDetail({
      activityCode: this.$route.params.activityCode
    });
    this.activityStatus = res.data.activityStatus;
    this.disInput = res.data.couponTypeDesc;
    this.couponForm = res.data;
  }
  editCoupon() {
    this.$router.push(`/marketing/created-coupon/${this.$route.params.activityCode}`);
  }
  routerPush() {
    this.$router.push(`/marketing/send-coupon/${this.$route.params.activityCode}`);
  }
}
